    //内容管理
   export default [{
        path: '/materialManagement',
        name: 'materialManagement',
        meta: {
            title: '素材管理'
        },
        //redirect: '/index',
        component: () =>
            import ( /* webpackChunkName: "pop-material-management" */ '../views/contentManagement/materialManagement.vue'),
    },
    {
        path: '/addMaterial',
        name: 'addMaterial',
        meta: {
            title: '新建素材'
        },
        //redirect: '/index',
        component: () =>
            import ( /* webpackChunkName: "pop-addMaterial" */ '../views/contentManagement/addMaterial.vue'),
    },
    {
        path: '/material-details',
        name: 'materialDetails',
        meta: {
            title: '素材详情'
        },
        //redirect: '/index',
        component: () =>
            import ( /* webpackChunkName: "pop-material-details" */ '../views/contentManagement/materialDetails.vue'),
    }]